module.exports = __webpack_public_path__ + "static/img/battle_report2.f1e6b05f.png";